import webPageIcon from "Static/svg/icon-webpage.svg";
import {
  MEDIA_ENTRY_APPLICATION,
  MEDIA_ENTRY_USER_CONTENT,
  MEDIA_ENTRY_WEBPAGE,
} from "fleet/constant/media-library";
import { PropTypeMediaEntryTypes } from "fleet/prop-types";
import {
  isImage,
  isUserContent,
  isVideo,
} from "fleet/view/media-library/utils";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import { download } from "util/download";

class ContentPreview extends React.PureComponent {
  static get propTypes() {
    return {
      hideFullscreen: PropTypes.func,
      mimeType: PropTypes.string,
      name: PropTypes.string,
      showFullscreen: PropTypes.func,
      type: PropTypeMediaEntryTypes,
      url: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      hideFullscreen: () => {},
      showFullscreen: () => {},
    };
  }

  constructor() {
    super();

    this._downloadContent = this._downloadContent.bind(this);
    this._viewFullscreen = this._viewFullscreen.bind(this);
    this.closeFullscreen = this.closeFullscreen.bind(this);
  }

  _downloadContent() {
    const { name, url } = this.props;

    download(url, name);
  }

  _getFullscreenType(mimeType) {
    if (isImage(mimeType)) {
      return "image";
    }

    if (isVideo(mimeType)) {
      return "video";
    }

    return null;
  }

  _viewFullscreen() {
    const { mimeType, name, showFullscreen, url } = this.props;
    const mediaType = this._getFullscreenType(mimeType);

    showFullscreen(url, mediaType, name);
  }

  closeFullscreen() {
    const { hideFullscreen } = this.props;

    hideFullscreen();
  }

  _renderNoPreview() {
    return <div className="cp-no-preview">No Preview</div>;
  }

  _renderImage(url) {
    return <img className="content-preview-media" src={url} />;
  }

  _renderContentPreview(props) {
    const { mimeType, url } = props;

    if (mimeType === MEDIA_ENTRY_WEBPAGE) {
      return this._renderIconPreview(webPageIcon);
    }

    if (mimeType.startsWith("image")) {
      return this._renderImage(url);
    }

    if (mimeType.startsWith("video")) {
      // Force video element to rerender.
      // https://stackoverflow.com/a/47382850/1870013
      return (
        <video
          key={url}
          className="content-preview-media"
          preload={false}
          controls={true}
        >
          <source src={url} />
        </video>
      );
    }

    return this._renderNoPreview();
  }

  _renderIconPreview(url) {
    return <img src={url} className="icon-preview-lg" />;
  }

  _renderPreview() {
    const { type, url } = this.props;

    if (type === MEDIA_ENTRY_WEBPAGE) {
      return this._renderIconPreview(webPageIcon);
    }

    if (!url) {
      return this._renderNoPreview();
    }

    if (type === MEDIA_ENTRY_USER_CONTENT) {
      return this._renderContentPreview(this.props);
    }

    if (type === MEDIA_ENTRY_APPLICATION) {
      return this._renderImage(url);
    }

    return this._renderImage(url);
  }

  render() {
    const { url, type } = this.props;
    const disabled = !url || !isUserContent(type);

    return (
      <div className="content-preview col-margin-fix">
        <div className="float-control-button-row button-spacing">
          <Button
            className="cp-expand clear-button"
            disabled={disabled}
            onClick={this._viewFullscreen.bind(this)}
            title="View Fullscreen"
          >
            <i className="fa fa-arrows-alt" aria-hidden="true" />
          </Button>
          <Button
            className="cp-download clear-button"
            disabled={disabled}
            onClick={this._downloadContent.bind(this)}
            title="Download"
          >
            <i className="fa fa-download" aria-hidden="true" />
          </Button>
        </div>
        {this._renderPreview()}
      </div>
    );
  }
}

export { ContentPreview };
